export const CHANGED_LANGUAGE_ACTION = 'CHANGED_LANGUAGE_ACTION';

export const changeLanguage = (language) => ({
  type: CHANGED_LANGUAGE_ACTION,
  payload: language,
});
